const getOperator = (operatorCode) => {
    let operator;

    if (operatorCode === 'lte') {
        operator = '<=';
    } else if (operatorCode === 'gte') {
        operator = '>=';
    } else if (operatorCode === 'equals') {
        operator = '=';
    }

    return operator;
};

export default getOperator;
